import logger from './logger';
export const formatUSD = (cents) => {
  if (!cents || cents === 0) return '$0.00';
  
  const dollars = cents / 100;
  return `$${dollars.toFixed(2)}`;
};

export const formatCurrency = (amount, currency = 'USD') => {
  if (!amount || amount === 0) return currency === 'USD' ? '$0.00' : '0.00';
  
  if (currency === 'USD') {
    const dollars = amount / 100;
    return `$${dollars.toFixed(2)}`;
  }
  
  return `${amount} ${currency}`;
};

// Legacy function for backward compatibility
export const formatTND = (millimes) => {
  logger.warn('formatTND is deprecated, use formatUSD instead');
  return formatUSD(millimes);
};
